import { QueryClient } from "@tanstack/react-query";

// The ONE QueryClient for the app (main.tsx mounts it; the auth store clears it).
//
// It lives in its own module — not in main.tsx — so the auth store can wipe it
// when the session ends. Without that, everything fetched for the previous
// account (matches, résumé, applications, admin data…) stays in the cache and
// is served instantly (staleTime 30s) to whoever signs in next on the same tab:
// found by the AUTH-03 browser journey (Alice's match card visible to Bob).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
  },
});
